import React from 'react';
import BenAndHollyAndLeo from '../images/thirteen.JPG';
import EWU from '../images/common/EWU.png';

import { column, row, halfImage } from '../../app/styles';

class Home extends React.Component {

    render() {
        return (
            <div style={column}>
                <div style={row}>
                    <img style={halfImage} src={BenAndHollyAndLeo} alt="Ben and Family" />
                    <div style={{ marginLeft: "5%" }}>
                        <h1 style={{ marginBottom: "0" }}>B.S. Mechanical Engineering</h1>
                        <h2 style={{ margin: "0" }}>Physics Minor</h2>
                        <h2 style={{ margin: "0" }}>Projected Graduation Date: March 2021</h2>
                        <img style={{ width: "80%", background: "rgba(265,265,265,0.8)", border: "5px solid black", padding: "4%" }} src={EWU} alt="EWU logo" />
                        <h3>Mechanical Engineering student (declared) at Eastern Washington University.</h3>
                        <h2 style={{ margin: "0" }}>Seeking a Mechanical Engineering internship.</h2>
                        <h3 style={{ margin: "0" }}>Open availability now through summer and beyond.</h3>
                    </div>
                </div>
                <div style={{marginBottom:"50px"}}></div>
            </div>
        );
    }
}

export default Home;